import React from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  ModalHeader,
  ModalFooter,
  LogoutContainer,
  StyledText,
  ButtonLogin,
  Buttons,
} from "./SmallScreensSideBarModal.styles";

import { ReactComponent as LogoIcon } from "../../assets/icons/Logo2.svg";
import { ReactComponent as LogoutIcon } from "../../assets/icons/logout.svg";

import LocaleSelection from "../LocaleSelection/LocaleSelection";
import Icon from "../utils/Icon";
import Modal from "./Modal";
import { useSelector } from "react-redux";
import { selectUserInfo } from "../../store/slices/user/slice";

const SmallScreensSideBarModal = ({
  open,
  close,
  setOpenSidebarModal,
  handleLogout,
  loggedIn,
  ar,
}) => {
  const navigate = useNavigate();
  const { fullName } = useSelector(selectUserInfo);
  const { t } = useTranslation();

  const navigateTo = (route) => {
    navigate(route);
    setOpenSidebarModal(false);
  };

  return (
    <Modal
      close={close}
      open={open}
      width={"fit-content"}
      height={"fit-content"}
    >
      <ModalHeader>
        {loggedIn ? (
          <StyledText style={{ marginBottom: -4 }}>{`${t(
            "hello"
          )}, ${fullName}!`}</StyledText>
        ) : (
          <LogoIcon width={80} height={80} />
        )}
        <LocaleSelection />
      </ModalHeader>

      {/* <Content>
      </Content> */}

      <ModalFooter $gap={loggedIn}>
        {loggedIn ? (
          <LogoutContainer onClick={handleLogout}>
            <StyledText>{t("logout")}</StyledText>
            <Icon icon={<LogoutIcon />} selectedLocale={ar} />
          </LogoutContainer>
        ) : (
          <Buttons $gap>
            <ButtonLogin
              onClick={() => {
                navigateTo("/");
              }}
            >
              {t("log-in")}
            </ButtonLogin>

            <ButtonLogin
              onClick={() => {
                navigateTo("/sign-up");
              }}
            >
              {t("sign-up")}
            </ButtonLogin>
          </Buttons>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default SmallScreensSideBarModal;
